import { useTranslation } from 'react-i18next'

import { useDocumentTitle } from '#/shared/lib/document-title'

export function useCampaignDocumentTitle(): void {
  const { t } = useTranslation()
  useDocumentTitle(t('documentTitle.campaign'))
}
